import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-home pl-1 pr-1 mx-auto max-w-(--breakpoint-4xl)" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-2 md:gap-2" }
const _hoisted_3 = { class: "space-y-2 col-span-3" }
const _hoisted_4 = { class: "space-y-2 rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03]" }
const _hoisted_5 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800" }
const _hoisted_6 = { class: "text-red-500 p-3 text-center" }
const _hoisted_7 = { class: "flex justify-between gap-2 mb-4" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800" }
const _hoisted_10 = { class: "flex justify-between gap-2 mb-4" }
const _hoisted_11 = { class: "flex justify-between mb-4" }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { class: "col-span-6 space-y-2 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] scroll-container" }
const _hoisted_14 = { class: "space-y-2 col-span-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Error_zone"], {
      error_zone: $setup.ErrorZone.application
    }, null, 8 /* PROPS */, ["error_zone"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["Error_zone"], {
            error_zone: $setup.ErrorZone.invoice_list
          }, null, 8 /* PROPS */, ["error_zone"]),
          _createVNode($setup["Invoice_list"], {
            files: $setup.files,
            selected_file_id: $setup.selected_file_id,
            selected_invoice_ids: $setup.selected_invoice_ids,
            onDelete_file: $setup.delete_file,
            onSelect_additional_invoices: $setup.select_additional_invoices,
            onClear_and_select_invoices: $setup.clear_and_select_invoices,
            onExclude_invoice: $setup.exclude_invoice,
            onMerge_invoices: $setup.merge_invoices
          }, null, 8 /* PROPS */, ["files", "selected_file_id", "selected_invoice_ids"]),
          _createVNode($setup["Error_zone"], {
            error_zone: $setup.ErrorZone.dropzone
          }, null, 8 /* PROPS */, ["error_zone"]),
          _createVNode($setup["Dropzone"], {
            onFile_accepted: $setup.file_accepted,
            onFile_loaded: $setup.file_loaded,
            onFile_load_error: _cache[0] || (_cache[0] = () => {})
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", _hoisted_6, "There are duplicated invoices", 512 /* NEED_PATCH */), [
            [_vShow, $setup.duplicated_invoices.length > 0]
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_basic_button, {
              onClick: _cache[1] || (_cache[1] = $event => ($setup.print_all($setup.invoices_to_save))),
              disabled: $setup.invoices_to_save.length <= 0 || $setup.duplicated_invoices.length > 0,
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "fa-solid fa-print" }, null, -1 /* CACHED */),
                _createTextVNode(" Print All ")
              ])),
              _: 1 /* STABLE */,
              __: [10]
            }, 8 /* PROPS */, ["disabled", "size"]),
            _createVNode(_component_basic_button, {
              onClick: _cache[2] || (_cache[2] = $event => ($setup.download_all($setup.invoices_to_save))),
              disabled: $setup.invoices_to_save.length <= 0 || $setup.duplicated_invoices.length > 0,
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "fa-solid fa-download" }, null, -1 /* CACHED */),
                _createTextVNode(" Download All ")
              ])),
              _: 1 /* STABLE */,
              __: [11]
            }, 8 /* PROPS */, ["disabled", "size"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode($setup["Confirm_button"], {
              onClick: _cache[3] || (_cache[3] = $event => ($setup.clear_all())),
              class: "error",
              size: $setup.Size.large
            }, {
              confirmation_text: _withCtx(() => _cache[12] || (_cache[12] = [
                _createElementVNode("p", null, "Are you sure you want to remove all files?", -1 /* CACHED */)
              ])),
              default: _withCtx(() => [
                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa-solid fa-circle-xmark" }, null, -1 /* CACHED */)),
                _cache[14] || (_cache[14] = _createTextVNode(" Clear All Files "))
              ]),
              _: 1 /* STABLE */,
              __: [13,14]
            }, 8 /* PROPS */, ["size"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_basic_button, {
              onClick: _cache[4] || (_cache[4] = $event => ($setup.router.push('/settings'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createElementVNode("i", { class: "fa-solid fa-gear" }, null, -1 /* CACHED */),
                _createTextVNode(" Settings ")
              ])),
              _: 1 /* STABLE */,
              __: [15]
            }, 8 /* PROPS */, ["size"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_basic_button, {
              onClick: _cache[5] || (_cache[5] = $event => ($setup.router.push('/reports'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createElementVNode("i", { class: "fa-regular fa-file-lines" }, null, -1 /* CACHED */),
                _createTextVNode(" Reports ")
              ])),
              _: 1 /* STABLE */,
              __: [16]
            }, 8 /* PROPS */, ["size"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_basic_button, {
              onClick: _cache[6] || (_cache[6] = $event => ($setup.router.push('/users'))),
              size: $setup.Size.large
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createElementVNode("i", { class: "fa-solid fa-users" }, null, -1 /* CACHED */),
                _createTextVNode(" Users ")
              ])),
              _: 1 /* STABLE */,
              __: [17]
            }, 8 /* PROPS */, ["size"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode($setup["Error_zone"], {
          error_zone: $setup.ErrorZone.pdf_viewer
        }, null, 8 /* PROPS */, ["error_zone"]),
        _withDirectives(_createVNode($setup["Invoice_comparison"], {
          invoice: $setup.selected_invoices[0]
        }, null, 8 /* PROPS */, ["invoice"]), [
          [_vShow, $setup.show_invoice_comparison]
        ]),
        _withDirectives(_createVNode($setup["Pdf_viewer"], {
          file: $setup.file,
          invoices: $setup.selected_invoices,
          is_stamping: $setup.is_stamping,
          onStamp_pdf: $setup.stamp_pdf,
          onRemove_pdf_page: $setup.remove_pdf_page
        }, null, 8 /* PROPS */, ["file", "invoices", "is_stamping"]), [
          [_vShow, !$setup.show_invoice_comparison]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode($setup["Invoice_information_edit"], {
          file: $setup.file,
          invoices: $setup.selected_invoices,
          is_stamping: $setup.is_stamping,
          onUpdate_invoice: $setup.update_invoice_and_stamp,
          onStart_stamping: _cache[7] || (_cache[7] = $event => ($setup.is_stamping = true)),
          onCancel_stamping: _cache[8] || (_cache[8] = $event => ($setup.is_stamping = false)),
          onToggle_invoice_comparison: _cache[9] || (_cache[9] = $event => ($setup.show_invoice_comparison = !$setup.show_invoice_comparison))
        }, null, 8 /* PROPS */, ["file", "invoices", "is_stamping"]),
        _createVNode($setup["Status"])
      ])
    ])
  ]))
}